import React from "react";
import { useDispatch } from "react-redux";
import Box from "../../../../components/Box";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../../components/CustomSingleSelect";
import { Helpers } from "../../../../helpers/Helpers";
import { GetCompanyListResponseItem } from "../../../../models/response/company/GetCompanyListResponse";
import { storeFastFirm, storeImageViewer } from "../../../../redux/reducers/authSlice";
import { CompanyService } from "../../../../services/CompanyService";
import { ConstantService } from "../../../../services/ConstantService";
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";

interface Props {
    generalInformationRef: any
    refNo: string | undefined
    setRefNo: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedCustomer: CustomSingleSelectModel | undefined
    setSelectedCustomer: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedOperationType: CustomSingleSelectModel | undefined
    setSelectedOperationType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedIncoterm: CustomSingleSelectModel | undefined
    setSelectedIncoterm: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedOrderStatus: CustomSingleSelectModel | undefined
    setSelectedOrderStatus: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
}

const GeneralInformation = ({
    generalInformationRef,
    refNo,
    setRefNo,
    selectedCustomer,
    setSelectedCustomer,
    selectedOperationType,
    setSelectedOperationType,
    selectedIncoterm,
    setSelectedIncoterm,
    selectedOrderStatus,
    setSelectedOrderStatus,
}: Props) => {
    const dispatch = useDispatch();

    return (
        <div className='containerPart' ref={generalInformationRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                    <div className='row'>
                        <div className="col-md-4">
                            <div>
                                <label htmlFor="exampleFormControlInput1" className="form-label">Ref No</label>
                                <input style={{ border: '1px solid #F1F1F4' }} value={refNo} onChange={(e) => setRefNo(e.target.value)} type="text" className="form-control form-control-solid" disabled />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label required">Müşteri</label>

                                <CustomSingleSelect
                                    selectedValue={selectedCustomer}
                                    onChange={setSelectedCustomer}
                                    insertable={{
                                        tooltipText: 'Firma seçilmeden basıldığında Yeni firma tanımlaması yapılmasını, firma seçimi yapıldıktan sonra basıldığında ise seçilen firmanın bilgilerinin Güncellenmesini sağlar.',
                                        onClick: () => {
                                            dispatch(storeFastFirm({
                                                companyId: selectedCustomer?.value,
                                                isCustomer: true,
                                                onSubmit: async (response) => {
                                                    setSelectedCustomer({ label: response.name, value: response.companyId })
                                                }
                                            }))
                                        }
                                    }}
                                    onMenuOpen={() => CompanyService.getCompanyList({ isCustomer: true })}
                                    labelName='name'
                                    valueName='companyId'
                                />
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div>
                                <label htmlFor="exampleFormControlInput1" className="form-label required">Operasyon Türü</label>

                                <CustomSingleSelect
                                    selectedValue={selectedOperationType}
                                    onChange={setSelectedOperationType}
                                    onMenuOpen={() => ConstantService.getConstantList('OPERATION_TYPE', undefined, undefined)}
                                    labelName='value'
                                    valueName='constantId'
                                />
                            </div>

                            <div className="mt-5">
                                <Box flexDirection="row">
                                    <Box justifyContent="flex-start">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Incoterm</label>
                                    </Box>
                                    <Box ml="5px" justifyContent="center">
                                        <i onClick={() => dispatch(storeImageViewer([Helpers.getEndpoint() + "/INCOTERMS.png"]))} className="actionIcon fs-6 text-primary fa fa-image" />
                                    </Box>
                                </Box>

                                <CustomSingleSelect
                                    selectedValue={selectedIncoterm}
                                    onChange={setSelectedIncoterm}
                                    onMenuOpen={() => ConstantService.getConstantList('INCOTERM')}
                                    labelName='additionalValue1'
                                    valueName='constantId'
                                    label2Name="value"
                                />
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div>
                                <label htmlFor="exampleFormControlInput1" className="form-label required">Sipariş Durumu</label>

                                <CustomSingleSelect
                                    selectedValue={selectedOrderStatus}
                                    onChange={setSelectedOrderStatus}
                                    onMenuOpen={() => ConstantService.getConstantList('ORDER_STATUS')}
                                    labelName='value'
                                    valueName='constantId'
                                />
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default GeneralInformation;